import React from "react";
import { useEffect } from 'react';
import { useQuill } from 'react-quilljs';
import BlotFormatter from 'quill-blot-formatter';
import 'quill/dist/quill.snow.css';
import AdminServices from "services/api/AdminServices";
import { baseURL, cdnURL } from "assets/Constant";
import { toast } from "react-toastify";

const generateFileName = (file) => {
    const ext = file.name.split(".").pop();
    const random = Math.random().toString(36).substring(2, 8);
    return `kb-${Date.now()}-${random}.${ext}`;
};

const uploadImageToCDN = async (file) => {
    const fileName = generateFileName(file);
    const folderName = "app-images/imgs/knowledge-base/articles";

    const data = new FormData();
    data.append("file", file);

    const res = await AdminServices.updateToS3({ fileName, folderName, data });
    if (res?.type === true && res?.data === "success") {
        return `${cdnURL}${folderName}/${fileName}`;
    }
    throw new Error("Upload failed");
};

const toolbarOptions = [
    [{ header: [1, 2, 3, false] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    ['link', 'image', 'video'],
    [{ align: [] }],
    [{ color: [] }, { background: [] }],
    ['clean']
];

const Editor = ({ onChange }) => {
    const { quill, quillRef, Quill } = useQuill({
        modules: { blotFormatter: {}, toolbar: toolbarOptions, }
    });

    if (Quill && !quill) {
        Quill.register('modules/blotFormatter', BlotFormatter);
    }

    // 🔥 ADD THIS (image handler fix)
    useEffect(() => {
        if (quill) {
            const toolbar = quill.getModule('toolbar');

            toolbar.addHandler('image', function () {
                const input = document.createElement('input');
                input.setAttribute('type', 'file');
                input.setAttribute('accept', 'image/*');
                input.click();

                input.onchange = async () => {
                    const file = input.files[0];
                    if (!file) return;

                    try {
                        const url = await uploadImageToCDN(file);
                        const range = quill.getSelection(true);
                        quill.insertEmbed(range.index, 'image', url);
                    } catch {
                        toast.error("Image upload failed");
                    }
                };
            });
        }
    }, [quill]);

    useEffect(() => {
        if (quill) {
            quill.on('text-change', (delta, oldContents) => {
                onChange(quill.root.innerHTML)
                let currrentContents = quill.getContents();
            });
        }
    }, [quill, Quill]);

    return (
        <div>
            <div ref={quillRef} style={{ height: "min(80vh, 500px)", overflow: "scroll", color: "black" }} />
        </div>
    );
};

export default Editor;

export const Editor2 = ({ onChange, content = null }) => {

    const { quill, quillRef, Quill } = useQuill({
        modules: { blotFormatter: {}, toolbar: toolbarOptions, }
    });

    if (Quill && !quill) {
        Quill.register('modules/blotFormatter', BlotFormatter);
    }

    useEffect(() => {
        if (quill) {
            const toolbar = quill.getModule('toolbar');

            toolbar.addHandler('image', function () {
                const input = document.createElement('input');
                input.setAttribute('type', 'file');
                input.setAttribute('accept', 'image/*');
                input.click();

                input.onchange = async () => {
                    const file = input.files[0];
                    if (!file) return;

                    try {
                        const url = await uploadImageToCDN(file);
                        const range = quill.getSelection(true);
                        quill.insertEmbed(range.index, 'image', url);
                    } catch {
                        toast.error("Image upload failed");
                    }
                };
            });
        }
    }, [quill]);

    useEffect(() => {
        if (quill) {
            quill.on('text-change', (delta, oldContents) => {
                onChange(quill.root.innerHTML)
            });
        }
    }, [quill, Quill]);

    useEffect(() => {
        if (quill && content) {
            quill.clipboard.dangerouslyPasteHTML(`${content}`)
        }
    }, [content]);

    return (
        <div>
            <div ref={quillRef} style={{ height: "min(80vh, 500px)", overflow: "scroll", color: "black" }} />
        </div>
    );
};